fragment EntitySummary on EntitySummary {
    id
    status
    summary
    userRating
    createdTime
    userRating
}
